import { IMAGES } from "@/lib/images";
import { Container, Overline, SectionHeading, Reveal } from "@/components/primitives";

const DISCIPLINES = [
  {
    n: "01",
    t: "Interior Design",
    d: "Designers assess architecture, materials, craftsmanship, atmosphere and the harmony of every space — from the arrival to the smallest detail.",
  },
  {
    n: "02",
    t: "Hospitality",
    d: "Hospitality experts evaluate guest care, service standards, communication and the quality of the welcome that defines an exceptional stay.",
  },
  {
    n: "03",
    t: "Technology",
    d: "Our technology team reviews the digital guest journey, operational readiness and how a property connects to the VillaFlow platform.",
  },
];

export default function SelectionTeam() {
  return (
    <section className="py-28 md:py-40" data-testid="selection-team">
      <Container>
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline>The Selection Team</Overline>
              <SectionHeading className="mt-8">Reviewed by hand. By people who know.</SectionHeading>
              <p className="mt-8 text-ivory/65 font-light leading-relaxed">
                Every request to join the Collection is reviewed individually by our Selection Team —
                a group that brings together three disciplines rarely found under one standard. No
                property is selected by an algorithm alone; each is considered by people who understand
                what makes a stay truly exceptional.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 relative aspect-[4/3] overflow-hidden">
                <img src={IMAGES.brightInterior} alt="An elegant Mediterranean interior" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-navy-900/20" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <div className="space-y-px bg-ivory/10 border border-ivory/10">
              {DISCIPLINES.map((d, i) => (
                <Reveal key={d.n} delay={i * 0.08}>
                  <div className="bg-navy-900 p-8 md:p-10 group hover:bg-navy-800 transition-colors duration-700">
                    <div className="flex items-baseline gap-6">
                      <span className="font-serif text-gold/40 text-4xl group-hover:text-gold/70 transition-colors duration-700">{d.n}</span>
                      <div>
                        <h3 className="font-serif text-2xl md:text-3xl text-ivory">{d.t}</h3>
                        <p className="mt-3 text-ivory/55 font-light leading-relaxed">{d.d}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
